export const DisplayType = {
  首屏: 'default',
  视频: 'video',
  羁绊: 'card',
  mmd: 'mmd',
};
